import React, { useState } from 'react';

const AccountantsocietyShifarasPatra = () => {
  const [selectedDate, setSelectedDate] = useState('2026-02-17');
  const [searchTerm, setSearchTerm] = useState('');

  const societyData = [
    {
      id: 1,
      taluka: 'भिवंडी',
      schemeName: 'प्रधानमंत्री आदि आदर्श ग्रामविकास योजना सन 2023-24',
      workName: 'कुहे अंतर्गत सिमेंट रस्त्याचे बांधकाम करणे ता. भिवंडी Rs- 1000000.00',
      societyName: 'जय भवानी मजूर संस्था, भिवंडी'
    },
    {
      id: 2,
      taluka: 'शहापूर',
      schemeName: 'प्रधानमंत्री आदि आदर्श ग्रामविकास योजना सन 2023-24',
      workName: 'कोथळे अंतर्गत रस्ता तयार करणे ता. शहापूर Rs- 1000000.00',
      societyName: 'शिवाजी मजूर संस्था, शहापूर'
    },
    {
      id: 3,
      taluka: 'मुरबाड',
      schemeName: 'प्रधानमंत्री आदि आदर्श ग्रामविकास योजना सन 2023-24',
      workName: 'देवपे येथे रस्ता तयार करणे ता. मुरबाड Rs- 1000000.00',
      societyName: 'महात्मा गांधी मजूर संस्था, मुरबाड'
    }
  ];

  const handleSearch = () => {
    console.log('Searching for date:', selectedDate);
  };

  const handleCopy = () => {
    console.log('Copy data');
  };

  const handleExcel = () => {
    console.log('Export to Excel');
  };

  const handlePrint = () => {
    console.log('Print data');
  };

  const handleLetterClick = (item) => {
    const params = new URLSearchParams({
      id: item.id || '',
      taluka: item.taluka || '',
      schemeName: item.schemeName || '',
      workName: item.workName || '',
      subEngineerName: item.societyName || '',
      mobile: item.mobile || '9876543210',
      address: item.address || 'जिल्हा परिषद ठाणे',
      estimatedAmount: item.estimatedAmount || '1000000.00',
      date: item.date || '17/02/2026',
      meetingDate: item.meetingDate || '17/02/2026'
    });
    window.open(`/accountant/subhe-work-order-print?${params.toString()}`, '_blank');
  };

  const handlePassbookClick = (item) => {
    console.log('Passbook clicked for:', item);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-slate-800 text-white shadow-md">
        <div className="container mx-auto px-6 py-6">
          <div className="text-center">
            <h1 className="text-3xl font-bold mb-2">मजूर संस्था शिफारस पत्र यादी</h1>
            <div className="w-24 h-0.5 bg-blue-400 mx-auto mb-3"></div>
            <h2 className="text-lg font-normal">जिल्हा परिषद / मजूर संस्था शिफारस पत्र यादी</h2>
          </div>
        </div>
      </div>

      {/* Search and Action Section */}
      <div className="container mx-auto px-6 py-6">
        <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
            {/* Left side - Date picker and action buttons */}
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <div className="flex flex-col">
                <label htmlFor="lottery-date" className="text-gray-700 font-medium mb-1">
                  लॉटरीची तारीख निवडा
                </label>
                <input
                  type="date"
                  id="lottery-date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded text-gray-700 focus:border-blue-500 focus:outline-none"
                />
              </div>
              <button 
                onClick={handleSearch}
                className="bg-blue-600 text-white px-6 py-2 rounded font-medium hover:bg-blue-700 transition-colors"
              >
                Search
              </button>
              <div className="flex gap-2">
                <button 
                  onClick={handleCopy}
                  className="bg-gray-600 text-white px-4 py-2 rounded font-medium hover:bg-gray-700 transition-colors flex items-center gap-1"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                  Copy
                </button>
                <button 
                  onClick={handleExcel}
                  className="bg-green-600 text-white px-4 py-2 rounded font-medium hover:bg-green-700 transition-colors flex items-center gap-1"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Excel
                </button>
                <button 
                  onClick={handlePrint}
                  className="bg-purple-600 text-white px-4 py-2 rounded font-medium hover:bg-purple-700 transition-colors flex items-center gap-1"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                  </svg>
                  Print
                </button>
              </div>
            </div>

            {/* Right side - Search input */}
            <div className="flex items-center gap-2">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded text-gray-700 focus:border-blue-500 focus:outline-none w-64"
              />
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="mt-6 bg-white rounded-lg shadow border border-gray-200">
          <div className="bg-gray-100 px-4 py-3 border-b border-gray-300">
            <h3 className="text-base font-semibold text-gray-800">मजूर संस्था शिफारस पत्र यादीची माहिती</h3>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead className="bg-slate-700 text-white">
                <tr>
                  <th className="px-4 py-3 text-center font-medium text-sm border border-gray-300">#</th>
                  <th className="px-4 py-3 text-left font-medium text-sm border border-gray-300">तालुका</th>
                  <th className="px-4 py-3 text-left font-medium text-sm border border-gray-300">कामाचे नाव</th>
                  <th className="px-4 py-3 text-left font-medium text-sm border border-gray-300">मजूर संस्थाचे नाव</th>
                  <th className="px-4 py-3 text-center font-medium text-sm border border-gray-300">वर्क ऑर्डर</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {societyData.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-3 text-sm font-medium text-gray-900 border border-gray-300 text-center">{item.id}</td>
                    <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{item.taluka}</td>
                    <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{item.workName}</td>
                    <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{item.societyName}</td>
                    <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300 text-center">
                      <button 
                        onClick={() => handleLetterClick(item)}
                        className="text-blue-600 hover:text-blue-800 transition-colors mx-auto"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                        </svg>
                      </button>
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountantsocietyShifarasPatra;
